// PDF Assets - SVG Logos and Icons

// Import SVG files as strings for PDF generation
import stmLogoSvg from './stmilogo.svg?raw'
// Import PNG logo as URL for PDF generation
import tifLogoPng from './tiflogo.png'

// Export all PDF-related assets
const PDF_ASSETS = {
  logos: {
    stm: stmLogoSvg,
    // Add more logos here as needed
    // company: companyLogoSvg,
    // certification: certificationLogoSvg,
  },
  icons: {
    // Add PDF icons here if needed
  }
}

// Individual exports for convenience
export const STM_LOGO = stmLogoSvg
export const CERT_LOGO = tifLogoPng

// Asset utilities (optional - for future use)
export const getPdfAsset = (category: keyof typeof PDF_ASSETS, name: string): string | undefined => {
  const categoryAssets = PDF_ASSETS[category] as Record<string, string>
  return categoryAssets?.[name]
}

export { default as stmilogo } from './stmilogo.svg?url';
export { default as certlogo } from './tiflogo.png'; 